export enum AccessAllowedEnum {
  All,
  ServiceRFIDcard,
}
